<template>
  <a-form-model ref='form' :model='model' :rules='validatorRules'>
    <a-form-model-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='质疑说明' prop='fff' required>
      <a-textarea placeholder='请输入质疑该对象的原因' v-model='model.fff'></a-textarea>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
export default {
  name: 'Step6',
  props: ['model'],
  data() {
    return {
      labelCol: {
        xs: { span: 12 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 8 }
      },
      validatorRules: {},
    }
  },
  created() {
  },
  methods: {
    /**
     * 当前步骤表单验证逻辑
     */
    validate() {
      let result = false
      this.$refs.form.validate((valid, errorFields) => {
        if (valid) {
          result = true
        }
      })
      return result
    }
  }


}
</script>

<style scoped>

</style>
